import { Component} from '@angular/core';
import { RouterOutlet } from '@angular/router';
//import { environment } from '../environments/environment';
declare function getMapApiurl(url1:string): void;

@Component({
    selector: 'app-root',
    standalone: true,
    templateUrl: './app.component.html',
    imports: [RouterOutlet]
})
export class AppComponent {
    //googleconf=environment.url+"/stamp/map/config";
    googleconf="/stamp/map/config";
    ngOnInit(): void {
       
        getMapApiurl(this.googleconf);
    }

}
